<template>
    <el-dialog
        title="审批交接"
        :visible.sync="approvalHandoverDialog"
        width="520px"
        :before-close="handleDialogClose"
        :close-on-click-modal="false"
        class="custom-form-dialog"
    >
        <el-form ref="formData" :rules="formRules" :model="formData" label-position="top" v-loading="formLoading">
            <el-form-item label="被交接人" prop="receiver">
                <div class="head_user">
                    <img :src="receiverInfo && receiverInfo.avatar ? receiverInfo.avatar : defaultImg" alt="" />{{
                        receiverInfo && receiverInfo.name
                    }}
                </div>
            </el-form-item>
            <el-form-item label="交接人" prop="handler">
                <el-select
                    placeholder="请选择交接人"
                    :remote-method="getUserList"
                    filterable
                    remote
                    v-model="formData.handler"
                >
                    <el-option :key="user.uid" :label="user.name" :value="user.uid" v-for="user in userList">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="交接内容" prop="role" class="label-bold">
                <div class="handover_content">
                    <p>审批身份</p>
                    <el-checkbox-group v-model="formData.role">
                        <el-checkbox :disabled="roleData.indexOf('1') > -1 ? false : true" label="1"
                            >审批人</el-checkbox
                        >
                        <el-checkbox :disabled="roleData.indexOf('2') > -1 ? false : true" label="2"
                            >抄送人</el-checkbox
                        >
                        <el-checkbox :disabled="roleData.indexOf('3') > -1 ? false : true" label="3"
                            >办理人</el-checkbox
                        >
                        <!-- <el-checkbox :disabled="roleData.indexOf('4') > -1 ? false :true" label="4">审批管理员</el-checkbox> -->
                    </el-checkbox-group>
                </div>
            </el-form-item>
            <div class="prompt_text">
                交接说明：
                <br />交接后，在"被交接人"对应的节点，都会替换为"交接人"。
                <br />"被交接人"的待处理审批也会同时替换为"交接人".
            </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click.stop="handleDialogClose" :disabeld="btnDisabled">取消</el-button>
            <el-button type="primary" @click.stop="handleDialogConfirm" :disabeld="btnDisabled">确定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { GetUserList, ApproveHandover } from "@/api";
export default {
    name: "approvalHandoverDialog",
    props: {
        approvalHandoverDialog: {
            type: Boolean,
            default: false,
        },
        approvalHandoverDetails: {
            type: Object,
            default: () => {},
        },
        receiverInfo: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            defaultImg: require("@/assets/images/default.jpg"),
            formLoading: false,
            formData: {
                receiver: "", // 被交接人
                handler: "", // 交接人
                role: [], // 角色类型 1=审批人 2=抄送人 3=办理人
                approval_set_id: [], // 审批类型id
                approval_ids: [], // 涉及到的待审批id
            },
            formRules: {
                handler: [{ required: true, message: "请选择交接人" }],
            },
            userList: [],
            roleData: [],
            btnDisabled: false,
        };
    },
    created() {
        this.getUserList();
        if (this.approvalHandoverDetails) {
            this.formData.approval_set_id = Array.isArray(this.approvalHandoverDetails.approval_set_id)
                ? this.approvalHandoverDetails.approval_set_id
                : [this.approvalHandoverDetails.approval_set_id];
            this.formData.approval_ids = this.approvalHandoverDetails.approval_ids;
            this.formData.receiver = this.approvalHandoverDetails.receiver;
            this.roleDataFunction([this.approvalHandoverDetails]);
        }
    },
    methods: {
        getUserList(name) {
            GetUserList({ keyword: name }).then((res) => {
                if (res.code == 200) {
                    this.userList = res.data || [];
                }
            });
        },
        handleDialogClose() {
            this.$emit("update:approvalHandoverDialog", false);
        },
        handleDialogConfirm() {
            this.$refs.formData.validate((valid) => {
                if (valid) {
                    this.formLoading = true;
                    this.btnDisabled = true;
                    ApproveHandover(this.formData)
                        .then((res) => {
                            if (res.code === 200) {
                                this.btnDisabled = false;
                                this.formLoading = false;
                                this.$message({
                                    message: res.message,
                                    type: "success",
                                    duration: 1000,
                                    onClose: () => {
                                        this.handleDialogClose();
                                        this.$emit("success");
                                    },
                                });
                            } else {
                                this.btnDisabled = false;
                                this.formLoading = false;
                                this.$message.error(res.message);
                            }
                        })
                        .catch(() => {
                            this.formLoading = false;
                            this.btnDisabled = false;
                        });
                }
            });
        },

        roleDataFunction(data) {
            this.roleData = [];
            data.forEach((item, key) => {
                if (item.role_name.indexOf("审批人") > -1) {
                    this.roleData.push("1");
                }
                if (item.role_name.indexOf("抄送人") > -1) {
                    this.roleData.push("2");
                }
                if (item.role_name.indexOf("办理人") > -1) {
                    this.roleData.push("3");
                }
                // if(item.role_name.indexOf('审批管理员') > -1){
                //     this.roleData.push('4')
                // }
            });
            this.roleData = [...new Set(this.roleData)];
            this.formData.role = JSON.parse(JSON.stringify(this.roleData));
        },
    },
};
</script>
<style lang="scss" scoped>
.custom-form-dialog ::v-deep .el-form--label-top .el-form-item__content {
    height: auto;
    line-height: normal;
}
.head_user {
    width: 100%;
    display: flex;
    align-items: center;
    img {
        width: 22px;
        height: 22px;
        border-radius: 50%;
        margin-right: 8px;
    }
}
.handover_content {
    border-radius: 6px;
    background: rgba(247, 248, 250, 1);
    padding: 8px 12px;
    box-sizing: border-box;
    p {
        font-size: 14px;
        color: rgba(51, 51, 51, 1);
        line-height: 22px;
        margin-bottom: 8px;
    }
}
.prompt_text {
    background: #edf0f4;
    padding: 8px;
    border-radius: 2px;
    line-height: 22px;
    border: none;
    color: rgba(102, 102, 102, 1);
    font-size: 12px;
}
</style>
